import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Mail, Phone, MapPin } from "lucide-react";

const ContactInfo = () => {
  return (
    <Card className="shadow-xl bg-white/80 backdrop-blur-sm border-2 border-brand-purple/20">
      <CardHeader>
        <CardTitle className="text-2xl text-brand-purple">
          Contact Information
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center space-x-4">
          <div className="w-12 h-12 bg-brand-purple/20 rounded-full flex items-center justify-center">
            <Mail className="h-6 w-6 text-brand-purple" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">Email</h3>
            <p className="text-gray-600">contact@boboandteedee.com</p>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <div className="w-12 h-12 bg-teedee-blue/20 rounded-full flex items-center justify-center">
            <Phone className="h-6 w-6 text-teedee-blue" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">Phone</h3>
            <p className="text-gray-600">+1 (345) 923-5116</p>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          <div className="w-12 h-12 bg-bobo-green/20 rounded-full flex items-center justify-center">
            <MapPin className="h-6 w-6 text-bobo-green" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">Location</h3>
            <p className="text-gray-600">Grand Cayman, Cayman Islands</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ContactInfo;
